var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-button",
    {
      attrs: { icon: "el-icon-download", size: "small", type: "primary" },
      on: { click: _vm.DownloadTemplate },
    },
    [_vm._v(_vm._s(_vm.$t("receivablePayable.DownloadTemplate")))]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }